module.exports = __webpack_public_path__ + "img/opening_logo.11fcc28e.png";